// extracted by mini-css-extract-plugin
module.exports = {"headMinWidth":"azure_ad_headMinWidth__1EVvd","azureUserSyncTab":"azure_ad_azureUserSyncTab__kxRpC","azureUsersTableHeight":"azure_ad_azureUsersTableHeight__2wfnQ"};